// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_qn-5";
export var filledCircle = "_qn-4";
export var historyEntry = "_qn-3";
export var messageSideLeft = "_qn-1";
export var messageSideRight = "_qn-2";
export var orderTrackingCarouselWrapper = "_qn-6";
export var orderTrackingInfoContainer = "_qn-0";